import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useUser } from "../../auth/useUser";
import { paths } from "../../utils/routerPaths";
import useScript from "../../hooks/useScript";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logoPrakerja from "../../assets/img/icons/Logo-kartu-prakerja.png";
import logoMerdeka from "../../assets/img/icons/kampusmerdeka_small.png";
import logoUdemy from "../../assets/img/icons/udemy.png";
import { basePath } from "../../api/basePath";
import ikon1 from "../../assets/img/icons-new/1.png";
import ikon2 from "../../assets/img/icons-new/2.png";
import ikon3 from "../../assets/img/icons-new/3.png";
import ikon4 from "../../assets/img/icons-new/4.png";
import ikon5 from "../../assets/img/icons-new/5.png";
import ikon6 from "../../assets/img/icons-new/6.png";
import ikon7 from "../../assets/img/icons-new/7.png";
import ikon8 from "../../assets/img/icons-new/8.png";
import ikon9 from "../../assets/img/icons-new/9.png";
import ikon10 from "../../assets/img/icons-new/10.png";
import ikon11 from "../../assets/img/icons-new/11.png";
import ikon12 from "../../assets/img/icons-new/12.png";
import ikon13 from "../../assets/img/icons-new/13.png";
import ikon14 from "../../assets/img/icons-new/14.png";

import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "25%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    minHeight: "355px",
  },
  overlay: {
    zIndex: "1000",
  },
};

const Header2 = () => {
  const [menu, setMenu] = useState(true);

  const toggleNavbar = () => {
    //console.log("Mid");
    setMenu(!menu);
  };

  const user = useUser("");

  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [path, setPath] = useState("");

  // const { data: dataAuth, loading: loadingAuth } =
  //   useFetchDataWithAuth("cek_credential");
  // TODO this is dummy data
  const dataAuth = {
    data: [
      {
        name: "Akun",
      },
    ],
  };
  const loadingAuth = false;

  // useEffect(() => {
  //   setPath(navigate.pathname);
  // }, [navigate]);

  useEffect(() => {
    let elementId = document.getElementById("navbar");
    document.addEventListener("scroll", () => {
      if (window.scrollY > 170) {
        elementId.classList.add("is-sticky");
      } else {
        elementId.classList.remove("is-sticky");
      }
    });
    // window.scrollTo(0, 0);
  });

  const classOne = menu
    ? "collapse navbar-collapse"
    : "collapse navbar-collapse show";
  const classTwo = menu
    ? "navbar-toggler navbar-toggler-right collapsed"
    : "navbar-toggler navbar-toggler-right";

  const signButton = (
    <ul className="navbar-nav">
      <li className="nav-item">
        <div className="mt-3">
          <Link to={basePath.login}>
            <p className="e-btn e-btn-border rounded-pill">Sign In</p>
          </Link>
        </div>
      </li>
      <li className="nav-item">
        <div className="mt-3">
          <Link to="/signup">
            <p className="e-btn rounded-pill pl-20 pr-20">Sign Up</p>
          </Link>
        </div>
      </li>
    </ul>
  );

  const signButtonMobile = (
    <li className="nav-item">
      <div className="container">
        <div className="row">
          <div className="col">
            <ul className="megamenu-submenu">
              <h4 className="fw-bold"> Akun</h4>
            </ul>
            <ul className="megamenu-submenu">
              <div className="d-flex">
                <div className="mt-3 bd-highlight">
                  <Link
                    style={{ marginLeft: "0px", paddingLeft: "0px" }}
                    to={basePath.login}
                  >
                    <p className="e-btn e-btn-border rounded-pill pl-20 pr-20">
                      Sign In
                    </p>
                  </Link>
                </div>

                <div className="mt-3 bd-highlight">
                  <Link to="/signup">
                    <p className="e-btn rounded-pill pl-20 pr-20">Sign Up</p>
                  </Link>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </li>
  );

  function refreshPage() {
    window.location.reload(false);
  }

  const logOut = () => {
    localStorage.removeItem("token");
    // navigate("/");
    refreshPage();
  };

  const userProfile = (
    <ul className="navbar-nav">
      <li className="nav-item">
        <Link to="#">
          <a
            onClick={(e) => e.preventDefault()}
            className="dropdown-toggle nav-link"
          >
            {user ? dataAuth.data[0].name : "Akun"}
          </a>
        </Link>
        <ul className="dropdown-menu" id="dropdown-menu-hidden">
          <li className="nav-item">
            <Link to="/myfreecourse">My Course</Link>
          </li>
          <li className="nav-item">
            <Link to="/profile">My Profile</Link>
          </li>
          <li className="nav-item">
            <Link to="/myportofolio">My Portofolio</Link>
          </li>
          <li className="nav-item">
            <span className="btn btn-altdanger ml-20" onClick={logOut}>
              Logout
            </span>
          </li>
        </ul>

        {/* <img
          src={
            dataAuth?.data[0].photo
              ? "https://portal2.bisaai.id:8080/bisa_business_dev/users/media/" +
                dataAuth.data[0].photo
              : "/assets/img/profile/blankprofile.png"
          }
          className="rounded-circle header__profile img-thumbnail"
          style={{ objectFit: "cover" }}
        />{" "} */}
      </li>
    </ul>
  );

  const userProfileMobile = (
    <li className="nav-item">
      <div className="container">
        <div className="row">
          <div className="col">
            <ul className="megamenu-submenu">
              <li>
                <Link to="#">
                  <h4 onClick={(e) => e.preventDefault()} className="fw-bold">
                    {user ? dataAuth.data[0].name : "Akun"}
                  </h4>
                </Link>
              </li>
            </ul>
          </div>
          <div className="col">
            {/* <h6 className="submenu-title">Pages I</h6> */}
            <ul className="megamenu-submenu">
              <li>
                <Link to="/myfreecourse">My Course</Link>
              </li>
              <li>
                <Link to="/profile">My Profile</Link>
              </li>
              <li>
                <Link to="/myportofolio">My Portofolio</Link>
              </li>
              <li className="mt-3">
                <button className="btn btn-altdanger" onClick={logOut}>
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </li>
  );

  const Logo = () => {
    {
      /* make if window widht > 100px choose another image */
    }
    if (window.innerWidth >= 768) {
      return (
        <span className="navbar-brand">
          <img
            className="logo-header"
            src="/assets/img/homepage/logo_sehat.png"
            alt="logo"
          />
        </span>
      );
    } else {
      return (
        <span className="navbar-brand">
          <img
            className="logo-header"
            src="/assets/img/homepage/logo_sehat.png"
            alt="logo"
          />
        </span>
      );
    }
  };

  // const [modalIsOpen, setIsOpen] = useState(false);
  // function openModal() {
  //   setIsOpen(true);
  // }

  // function closeModal() {
  //   setIsOpen(false);
  // }

  let ikon = [
    ikon1, ikon2, ikon3, ikon4, ikon5, ikon6, ikon7, ikon8, ikon9, ikon10,
    ikon11, ikon12, ikon13, ikon14
  ];

  let logo = [
    logoPrakerja, logoMerdeka, logoUdemy
  ];


  const modalHeader = [
    {
      modalName: "modal1",
      modalTitle: "Course Learning",
      modalContent: [
        { text: "Healthy Course", image: ikon[5] },
        { text: "Healthy Class", image: ikon[6] },
        { text: "Healthy Class + On Job Training", image: ikon[7] }
      ]
    },
    {
      modalName: "modal2",
      modalTitle: "Special Program",
      modalContent: [
        { text: "Corporate Training Class", image: ikon[4] },
        { text: "Kampus Merdeka", image: logo[1] },
        { text: "Kartu Prakerja", image: logo[0] },
        { text: "Udemy Class", image: logo[2] }
      ]
    },
    {
      modalName: "modal3",
      modalTitle: "Certification",
      modalContent: [
        { text: "Sertifikasi BNSP", image: ikon[0] },
        { text: "Sertifikasi Internasional", image: ikon[1] },
      ]
    },
    {
      modalName: "modal4",
      modalTitle: "Lainnya",
      modalContent: [
        { text: "Portofolio Alumni", image: ikon[3] },
        { text: "Testimonial Alumni", image: ikon[8] },
        { text: "Gallery Pelatihan", image: ikon[2] },
      ]
    },
    {
      modalName: "modal5",
      modalTitle: "Akun",
      modalContent: [
        { text: "Sign In", image: ikon[12] },
        { text: "Sign Up", image: ikon[13] },
      ]
    }
  ]

  const [activeModal, setActiveModal] = useState({
    modal1: false,
    modal2: false,
    modal3: false,
    modal4: false,
    modal5: false,
  });

  const openModal = (modal) => {

    const modalData = modalHeader.find(m => m.modalName === modal);

    // setActiveModal({
    //   modal1: false,
    //   modal2: false,
    //   modal3: false,
    //   modal4: false,
    //   modal5: false,
    //   modal.modalName: true,
    // });

    setActiveModal(prev => {
      const modalState = Object.keys(prev).reduce((acc, key) => {
        acc[key] = key === modal;
        return acc;
      }, {});
      return modalState;
    });

    const selectedCourse = modalData.modalContent[0].text;
    setDesc({
      selectedCourse: selectedCourse,
      description: modalSelectionDesc[selectedCourse].description,
      image: modalSelectionDesc[selectedCourse].image,
      route: modalSelectionDesc[selectedCourse].route,
    });
  };

  const closeModal = (modalName) => {
    setActiveModal((prev) => ({ ...prev, [modalName]: false }));
  };

  const [modalDesc, setDesc] = useState({
    selectedCourse: "Healthy Course",
    description:
      "Belajar kesehatan dengan fleksibilitas penuh! Akses materi terbaik kapan saja, di mana saja, untuk meningkatkan pengetahuan dan keterampilan Anda.",
    image: ikon[5],
    route: paths.healthycourse,
  });

  const modalSelectionDesc = {
    "Healthy Course": {
      description:
        "Belajar kesehatan dengan fleksibilitas penuh! Akses materi terbaik kapan saja, di mana saja, untuk meningkatkan pengetahuan dan keterampilan Anda.",
      image: ikon[5],
      route: paths.healthycourse,
    },
    "Healthy Class": {
      description:
        "Program pelatihan mandiri dengan metode Asynchronous Learning untuk melatih kamu menjadi tenaga medis profesional yang kompetensinya tervalidasi dengan Credential Digital Certificate dan Credential Digital Badge.",
      image: ikon[6],
      route: paths.healthyclass,
    },
    "Healthy Class + On Job Training": {
      description:
        "Gabungkan teori dan praktik! Belajar di kelas interaktif, lalu terjun langsung ke dunia kerja untuk pengalaman nyata dan siap bersaing di industri kesehatan yang tervalidasi dengan Credential Digital Certificate dan Credential Digital Badge.",
      image: ikon[7],
      route: paths.healthyclassojt,
    },
    "Corporate Training Class": {
      description: "Tingkatkan Kompetensi dan Kemampuan Tenaga Medis Anda dengan Pelatihan dan Sertifikasi Medis Terbaik bersama Sehat Mudah!",
      image: ikon[4],
      route: paths.corporatetrainingclass,
    },
    "Kampus Merdeka": {
      description: "Ikuti program Magang dan Studi Independen Bersertifikat (MSIB) terkait Teknologi Kesehatan Tenaga Medis selama 1 semester di Sehat Mudah secara GRATIS!",
      image: logo[1],
      route: paths.kampusmerdeka,
    },
    "Kartu Prakerja": {
      description: "Ikuti pelatihan terkait Kesehatan dan Medis secara GRATIS di dr. Mekanik Academy menggunakan Kartu Prakerja kamu. Dapatkan juga bonus insentif karir dari Sehat Mudah!",
      image: logo[0],
      route: paths.prakerja,
    },
    "Udemy Class": {
      description: "Kelas Kursus Pelatihan Sehat Mudah di Platform Udemy",
      image: logo[2],
      route: "https://www.udemy.com/user/dr-mekanik-academy/",
    },
    "Sertifikasi BNSP": {
      description: "Buktikan keahlian Anda di bidang kesehatan dengan sertifikasi resmi dari BNSP. Diakui secara nasional, meningkatkan kredibilitas dan daya saing profesional Anda!",
      image: ikon[0],
      route: paths.sertifikasibnsp,
    },
    "Sertifikasi Internasional": {
      description: "Raih pengakuan global di dunia kesehatan! Sertifikasi internasional membuka peluang karier di berbagai negara dengan standar kompetensi kelas dunia.",
      image: ikon[1],
      route: paths.sertifikasiinternasional,
    },
    "Portofolio Alumni": {
      description: "Lihat bukti nyata keberhasilan alumni Sehat Mudah! Temukan kisah sukses dan pencapaian mereka di dunia kesehatan setelah mengikuti program kami.",
      image: ikon[3],
      route: paths.portofolio,
    },
    "Testimonial Alumni": {
      description: "Dengar langsung pengalaman menginspirasi dari alumni Sehat Mudah yang telah membuktikan keunggulan pelatihan kami dalam mengembangkan karier kesehatan mereka.",
      image: ikon[8],
      route: paths.testimonial,
    },
    "Gallery Pelatihan": {
      description: "Melihat kegiatan pelatihan Sehat Mudah secara visual! Galeri kami menampilkan momen berharga, kelas interaktif, dan latihan praktis yang telah mengubah banyak karier di bidang kesehatan.",
      image: ikon[2],
      route: paths.gallery,
    },
    "Sign In": {
      description: "Masuk ke akun Sehat Mudah anda untuk mengakses materi yang tersedia. Belum punya akun? tekan tombol Sign Up.",
      image: ikon[12],
      route: paths.login,
    },
    "Sign Up": {
      description: "Daftar dan bergabung dengan kami untuk mendapatkan akses ke materi tanpa batas! Sudah punya akun? tekan tombol Sign In.",
      image: ikon[13],
      route: paths.register,
    },
  };

  const ChangeModalDesc = (selected) => {
    if (modalSelectionDesc[selected]) {
      setDesc({
        selectedCourse: selected,
        description: modalSelectionDesc[selected].description,
        image: modalSelectionDesc[selected].image,
        route: modalSelectionDesc[selected].route,
      });
    } else {
      setDesc({
        selectedCourse: selected,
        description:
          "Belajar kesehatan dengan fleksibilitas penuh! Akses materi terbaik kapan saja, di mana saja, untuk meningkatkan pengetahuan dan keterampilan Anda.",
        image: ikon[5],
        route: paths.healthyclass,
      });
    }
  };

  return (
    <>
      {modalHeader.map((modal, index) => (
        <Modal
          key={index}
          isOpen={activeModal[modal.modalName]}
          onRequestClose={() => closeModal(modal.modalName)}
          style={customStyles}
          contentLabel=""
        >
          <div className="container modal-high">
            <h5 className="fw-bold text-center mx-auto mb-4">{modal.modalTitle}</h5>
            <div className="row">
              <div className="col-sm-12 col-md-4 d-flex mb-4">
                <div className="d-flex flex-column justify-content-evenly">
                  {modal.modalContent.map((content, indexes) => (
                    <Link to="" key={indexes}>
                      <div className="d-flex text-start justify-content-start align-items-center pe-4 mb-3">
                        <img
                          className="header__icon"
                          src={content.image}
                          alt="img not found"
                        />
                        <h5
                          className={`text-mute w-105 cursor-pointer ${modalDesc.selectedCourse === content.text
                            ? "fw-bold"
                            : "fw-light text-muted"
                            }`}
                          onClick={() => ChangeModalDesc(content.text)}
                        >
                          {content.text}
                        </h5>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
              <div className="col-sm-12 col-md-8 border-2 border-start" style={{ minHeight: "300px" }}>
                <div className="d-flex flex-column h-100">
                  <h5 className="fw-bold text-start top-0">{modalDesc.selectedCourse}</h5>
                  <p className="text-start p-scrollable">{modalDesc.description}</p>
                  <Link to={modalDesc.route}>
                    <strong>lihat selengkapnya </strong>
                    <i><FontAwesomeIcon icon="fa-solid fa-arrow-right" /></i>
                  </Link>
                  <img
                    src={modalDesc.image}
                    className="ms-auto mt-auto d-none d-md-block"
                    style={{ height: 110, width: "auto" }}
                  ></img>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      ))}

      <div id="navbar" className="navbar-area">
        <div className="texap-nav">
          <div className="container">
            <nav className="navbar navbar-expand-md navbar-light bg-light">
              <Link to="/">
                <Logo />
              </Link>

              <button
                onClick={toggleNavbar}
                className={classTwo}
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="icon-bar top-bar"></span>
                <span className="icon-bar middle-bar"></span>
                <span className="icon-bar bottom-bar"></span>
              </button>

              <div className={classOne} id="navbarSupportedContent">
                <ul className="navbar-nav">
                  <li className="nav-item megamenu">
                    <Link to="#">
                      <a
                        onClick={() => openModal("modal1")}
                        className="dropdown-toggle nav-link"
                      >
                        Course Learning
                      </a>
                    </Link>
                  </li>

                  <li className="nav-item megamenu">
                    <Link to="#">
                      <a
                        onClick={() => openModal("modal2")}
                        className="dropdown-toggle nav-link"
                      >
                        Special Program
                      </a>
                    </Link>
                  </li>
                  <li className="nav-item megamenu">
                    <Link to="#">
                      <a
                        onClick={() => openModal("modal3")}
                        className="dropdown-toggle nav-link"
                      >
                        Certification
                      </a>
                    </Link>
                  </li>

                  <li className="nav-item megamenu">
                    <Link to="#">
                      <a
                        onClick={() => openModal("modal4")}
                        className="dropdown-toggle nav-link"
                      >
                        Lainnya
                      </a>
                    </Link>
                  </li>

                  <li className="nav-item megamenu">
                    <Link to={user ? "/profile" : "#"}>
                      <a
                        onClick={() => openModal("modal5")}
                        className="dropdown-toggle nav-link"
                      >
                        Akun
                      </a>
                    </Link>
                  </li>

                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header2;
